//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPlacesNow } from '@/utils/event/members';

export default {
  data() {
    return {
      copied: false,
      members: 0,
    };
  },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    publicEvent() {
      return this.event?.public;
    },
  },
  created() {
    this.members = getPlacesNow(this.event);
  },
  methods: {
    copy() {
      const link = document.location.href;

      navigator.clipboard.writeText(link).then(
        () => {
          this.copied = true;
        },
        () => {
          console.error('clipboard write failed.');
        },
      );
    },
  },
};
